import request from '../utils/request'

export function add(object) {
  return request.post('/user/add', object)
}

export function put(object) {
  return request.put('/user', object)
}

export function list(object) {
  return request.post('/user/list', object)
}

export function deleteById(id) {
  return request.delete('/user/'+id)
}

export function login(object) {
  return request.post('/user/login', object)
}

export function getUserInfo() {
  return request.get('/user/getUserInfo')
}

export function updatePwd(object) {
  return request.put('/user/updatePwd', object)
}

export function updateAvatar(object) {
  return request.put('/user/updateAvatar', object)
}

export function queryIndexInfo() {
  return request.get('/user/queryIndexInfo')
}

export function queryById(id) {
  return request.get('/user/'+id)
}

export function logout() {
  return request.get('/user/logout')
}

export function frontQueryIndexInfo() {
  return request.get('/user/frontQueryIndexInfo')
}

export function getCurrentChatUser(id) {
  return request.get('/user/getCurrentChatUser/'+id)
}

export function authentication() {
  return request.get('/user/authentication')
}